import palette from "../../../theme/palette";
import { Loader } from "./style";

const CircularLoading = ({ size = "30px", color = palette.white }) => (
  <Loader size={size} color={color} />
);

export default CircularLoading;
